/*
 * chatbotReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 16-Apr-2025
 */

import { produce } from 'immer'
import { actionTypes } from '../actions/chatbot'

const ACTION_HANDLERS = {
  // @generator reducer:type:action
  [actionTypes.DO_CHATBOT_MOUNTED]: produce((draft, action) => {
    draft.isMounted = action.payload
  })
}

// The initial state of the chatbot
const initialState = {
  isMounted: false
}

const chatbot = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default chatbot
